import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TilesLayer } from '@tcc/treadstone';
import { BASE_FIELDVIEW_URL as BASE_URL } from '../../../constants/urls';
import { getFvpCacheBuster } from '../../../selectors/layerSelectors';
import { userSelector } from '../../../selectors/userSelectors';
import { getFieldBounds } from '../../../selectors/fieldSelectors';
import { logDmbError } from '../../../utils/error';

export class HarvestAndPlantingMap extends Component {
  shouldComponentUpdate(nextProps) {
    return JSON.stringify(this.props) !== JSON.stringify(nextProps);
  }

  onTileError = (error) => {
    const tileUrl = error.target.options.url || error.target._url;
    logDmbError(`Tile image not loaded: ${tileUrl}`);
  };

  render() {
    const {
      cacheBuster,
      crop,
      dates,
      fieldBounds,
      fieldUuid,
      layer,
      user,
    } = this.props;
    const { endDate, startDate, year } = dates;

    /* Cache buster value is generated from legend data, which may not be available yet. Avoid
       rendering until I have it to avoid extra downloads of images. */
    if (!cacheBuster) {
      return null;
    }

    const lastUrlPart = `{z}/{x}/{y}.png?startTime=${startDate}&endTime=${endDate}&cacheBuster=${cacheBuster}`;

    const firstPartUrl = `${BASE_URL}/tile/v3/${user.uuid}/${fieldUuid}/${year}/${crop}/${layer}/`

    const url = firstPartUrl + lastUrlPart;

    return (
      <TilesLayer
        bounds={fieldBounds}
        onTileError={(error) => this.onTileError(error)}
        url={url}
        zIndex={2}
        maxNativeZoom={20}
        maxZoom={20}
      />
    );
  }
}

HarvestAndPlantingMap.propTypes = {
  cacheBuster: PropTypes.string,
  crop: PropTypes.string.isRequired,
  dates: PropTypes.object.isRequired,
  fieldBounds: PropTypes.array.isRequired,
  fieldUuid: PropTypes.string.isRequired,
  layer: PropTypes.string.isRequired,
  user: PropTypes.object,
};

function mapStateToProps(state, props) {
  const activeMapLayer = state.layers.activeMapLayers[props.index];

  return {
    cacheBuster: getFvpCacheBuster(state, props),
    fieldBounds: getFieldBounds(state),
    fieldUuid: state.field.uuid.toUpperCase(),
    layer: activeMapLayer.id,
    user: userSelector(state)
  };
}

export default connect(mapStateToProps)(HarvestAndPlantingMap);
